import { TierRulesGridView } from '~/components/loyalty/tier-rules';
import { PageContainer } from '~/components/page-container';

export function TierRules() {
	return (
		<PageContainer>
			<TierRulesGridView />
		</PageContainer>
	);
}
